"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "contract",
    path: "/contracts/:id",
    component: "Contract",
    params: [{
            name: "id",
            prop: "contractId",
        },
        {
            name: "rev",
            prop: "revision_number",
        },
    ]
});
let Contract = class Contract extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    contractId;
    onContract_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contractId");
    }
    revision_number;
    onRevision_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("revision_number");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tabManager;
    async $$load_tabManager() {
        return new this.$app.utils.LazyTabManager();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_contract', { asResource: true, parameters: { id: this.contractId, rev: this.revision_number } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2285343489561581_to;
    dataMembers = ['tabManager', 'item', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                tabManager: null,
                item: null,
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2285343489561581_to: {
                    name: "app.contracts",
                },
            },
        };
    }
    get readonly() {
        if (this.loaded) {
            return this.item.locked;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.snapshot('contract_number'),
                    this.$fn.gettext("Contract"),
                ],
                icon: this.$config.contract.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3134_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2095089031469157_clickPreventStop(event, scope) {
        return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_9004123373732307_success(event, scope) {
        return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
    }
    async evh_2679161326024595_reload(event, scope) {
        return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
    }
    async evh_7987652045662005_reload(event, scope) {
        return await this.actions.evh_7987652045662005_reload.executeFromDOM(this, event, scope);
    }
    async evh_6490121676898844_reload(event, scope) {
        return await this.actions.evh_6490121676898844_reload.executeFromDOM(this, event, scope);
    }
    async evh_2789477278097085_reload(event, scope) {
        return await this.actions.evh_2789477278097085_reload.executeFromDOM(this, event, scope);
    }
    async evh_6182083303232630_reload(event, scope) {
        return await this.actions.evh_6182083303232630_reload.executeFromDOM(this, event, scope);
    }
    async evh_5361955607147334_reload(event, scope) {
        return await this.actions.evh_5361955607147334_reload.executeFromDOM(this, event, scope);
    }
    async evh_384677887161204_reload(event, scope) {
        return await this.actions.evh_384677887161204_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3134 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3134_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3133 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3134,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3133],
        });
        const act_2095089031469157_reloadComponentData_3136 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_2095089031469157_clickPreventStop_3135 = new core_1.actions.EventHandlerImpl({
            action: act_2095089031469157_reloadComponentData_3136,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2095089031469157_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2095089031469157_clickPreventStop_3135],
        });
        const act_9004123373732307_closeComponent_3138 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_9004123373732307_success_3137 = new core_1.actions.EventHandlerImpl({
            action: act_9004123373732307_closeComponent_3138,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_9004123373732307_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_9004123373732307_success_3137],
        });
        const act_2679161326024595_reloadComponentData_3140 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2679161326024595_reload_3139 = new core_1.actions.EventHandlerImpl({
            action: act_2679161326024595_reloadComponentData_3140,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2679161326024595_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2679161326024595_reload_3139],
        });
        const act_7987652045662005_reloadComponentData_3142 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7987652045662005_reload_3141 = new core_1.actions.EventHandlerImpl({
            action: act_7987652045662005_reloadComponentData_3142,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7987652045662005_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7987652045662005_reload_3141],
        });
        const act_6490121676898844_reloadComponentData_3144 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6490121676898844_reload_3143 = new core_1.actions.EventHandlerImpl({
            action: act_6490121676898844_reloadComponentData_3144,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_6490121676898844_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6490121676898844_reload_3143],
        });
        const act_2789477278097085_reloadComponentData_3146 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2789477278097085_reload_3145 = new core_1.actions.EventHandlerImpl({
            action: act_2789477278097085_reloadComponentData_3146,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2789477278097085_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2789477278097085_reload_3145],
        });
        const act_6182083303232630_reloadComponentData_3148 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6182083303232630_reload_3147 = new core_1.actions.EventHandlerImpl({
            action: act_6182083303232630_reloadComponentData_3148,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_6182083303232630_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6182083303232630_reload_3147],
        });
        const act_5361955607147334_reloadComponentData_3150 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5361955607147334_reload_3149 = new core_1.actions.EventHandlerImpl({
            action: act_5361955607147334_reloadComponentData_3150,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5361955607147334_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5361955607147334_reload_3149],
        });
        const act_384677887161204_reloadComponentData_3152 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_384677887161204_reload_3151 = new core_1.actions.EventHandlerImpl({
            action: act_384677887161204_reloadComponentData_3152,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_384677887161204_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_384677887161204_reload_3151],
        });
        return {
            act_7315092382398562_closeModal_3134,
            evh_7315092382398562_close_3133,
            evh_7315092382398562_close,
            act_2095089031469157_reloadComponentData_3136,
            evh_2095089031469157_clickPreventStop_3135,
            evh_2095089031469157_clickPreventStop,
            act_9004123373732307_closeComponent_3138,
            evh_9004123373732307_success_3137,
            evh_9004123373732307_success,
            act_2679161326024595_reloadComponentData_3140,
            evh_2679161326024595_reload_3139,
            evh_2679161326024595_reload,
            act_7987652045662005_reloadComponentData_3142,
            evh_7987652045662005_reload_3141,
            evh_7987652045662005_reload,
            act_6490121676898844_reloadComponentData_3144,
            evh_6490121676898844_reload_3143,
            evh_6490121676898844_reload,
            act_2789477278097085_reloadComponentData_3146,
            evh_2789477278097085_reload_3145,
            evh_2789477278097085_reload,
            act_6182083303232630_reloadComponentData_3148,
            evh_6182083303232630_reload_3147,
            evh_6182083303232630_reload,
            act_5361955607147334_reloadComponentData_3150,
            evh_5361955607147334_reload_3149,
            evh_5361955607147334_reload,
            act_384677887161204_reloadComponentData_3152,
            evh_384677887161204_reload_3151,
            evh_384677887161204_reload,
            reload: act_2095089031469157_reloadComponentData_3136,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Contract.prototype, "contractId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contractId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Contract.prototype, "onContract_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Contract.prototype, "revision_number", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('revision_number'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Contract.prototype, "onRevision_number", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Contract.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Contract.prototype, "onSize", null);
Contract = __decorate([
    (0, vue_property_decorator_1.Component)()
], Contract);
exports.default = Contract;
vue_property_decorator_1.Vue.component("Contract", Contract);
